import dxTabPanel from 'devextreme/ui/tab_panel'
import dxPopup from 'devextreme/ui/popup'
import importTelas from '../telas/importTelas'
import { registrarAcessoRecente } from './acessosRecentes'
import {
    registrarAcessoChatFlutuante,
    registrarAcessoTela,
} from '../services/analytics/acessoTelas'
import ControleSessao from './ControleSessao'
import { PopUpPadrao } from './PopUpPadrao'

export default class ControleTabPadrao {
    classesIniciadas = {}
    tabPanelItems = [];
    idGlobal = 0;
    titleElements = [];
    chatAssistantOpen = false;
    popupChatInstance = null;
    /** Assinantes avisados quando a aba em foco muda (JOR4-7365, RN03). */
    ouvintesTelaAtiva = [];

    /**
     * @param {import('devextreme/ui/drawer').default} drawerInstance
     */
    constructor(drawerInstance) {
        this.render()

        // Só criar o chat flutuante para usuários internos e quando tem os envs definidos 🙏
        if (ControleSessao.getUsuarioInterno() && process.env.AI_SERVICE_URL && process.env.AI_SERVICE_TOKEN) {
            this.createFloatingChatButton()
        }

        this.drawerInstance = drawerInstance;
    }

    render() {
        this.renderTabPanel = this.tabPanel()
    }

    get tabPanelInstance() {
        return this.renderTabPanel.instance
    }

    tabPanel() {
        const content = $("#tabpanel-container")
        let instancia = this;

        const instance = new dxTabPanel(content, {
            // Classe própria para o CSS do Design System não vazar para os
            // outros dxTabPanel do sistema (popups de cadastro usam abas também).
            elementAttr: { class: "tabpanel-ds" },
            height: window.innerHeight - 55,
            dataSource: [],
            selectedIndex: 0,
            loop: false,
            animationEnabled: true,
            swipeEnabled: false,
            hoverStateEnabled: false,
            repaintChangesOnly: true,
            showNavButtons: true,
            scrollByContent: true,
            scrollingEnabled: true,
            noDataText: "",
            tabIndex: undefined,
            deferRendering: false,
            itemTitleTemplate: (itemData, itemIndex, itemElement) => {
                const content = $(itemElement)

                content.css('overflow', 'hidden');

                // .text() e não interpolação de string: o nome da aba vem do
                // cadastro de menus e pode ser renomeado por quem for.
                const titleTab = $("<span class='tabbar-ds-rotulo'></span>").text(itemData.nomeTela);
                instancia.titleElements[itemIndex] = titleTab;
                titleTab.appendTo(content)

                // A aba fixa não recebe o ✕: `removeTab` já a ignora, então o
                // botão apenas sugeria uma ação que nunca acontece. (JOR4-7565 /
                // RN01)
                if (itemData.fixa) return

                const botaoFechar = $(
                    `<button type="button" class="tabbar-ds-fechar" aria-label="Fechar aba">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                             stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                        </svg>
                    </button>`
                );

                botaoFechar.on('click', (evento) => {
                    // Sem isto, o clique também seleciona a aba que está sendo
                    // fechada, e a tela pisca antes de sumir.
                    evento.stopPropagation()
                    this.removeTab(itemData.ID)
                })

                botaoFechar.appendTo(content)
            },
            onSelectionChanged: ({ addedItems, removedItems }) => {
                if (!addedItems.length) return

                const actualTab = addedItems[0];
                const prevTab = removedItems.length ? removedItems[0] : null;

                if (this.getClasseIniciada(actualTab.classe.name, actualTab.ID)?.reloadGrid) {
                    this.getClasseIniciada(actualTab.classe.name, actualTab.ID).reloadGrid()
                }

                if (prevTab && this.getClasseIniciada(actualTab.classe.name, actualTab.ID)?.stopReload) {
                    this.getClasseIniciada(actualTab.classe.name, actualTab.ID).stopReload()
                }

                // Antes das chamadas de analytics, de propósito: `ga` é global
                // injetado pelo Google Analytics e some com ad-blocker ou proxy
                // corporativo. Depois delas, um ReferenceError abortaria o
                // handler e o destaque do menu (RN03) congelaria em silêncio.
                this.notificarTelaAtiva()

                // //Altera URL e titulo da aba do navegador
                document.title = `${actualTab.nomeTela} - ${ControleSessao.getCustomTitle()}`;

                if (typeof ga !== 'function') return

                ga(
                    'send',
                    'event',
                    'Troca_de_aba',
                    'change_tab',
                    `{
                        ID_USUARIO: ${ControleSessao.getIdUsuario()},
                        ID_EMPRESA: ${ControleSessao.getIdEmpresa()},
                        IDS_FILIAIS: ${ControleSessao.getFiliais().map((filial) => filial.CAB_RAZAO).join(',')},
                        DATA_HORA: ${new Date()},
                        ABA_ABERTA: ${actualTab.nomeTela}
                    }`
                );

                ga('send', 'pageview', `${window.location.pathname}${this.slugfy(actualTab.nomeTela)}`);
            },
            itemTemplate: async (itemData, itemIndex, itemElement) => {
                try {
                    const invokeClass = new itemData.classe

                    this.classesIniciadas[`${itemData.classe.name}_${itemData.ID}`] = invokeClass

                    if (invokeClass.setControleTab) {
                        invokeClass.setControleTab(this)
                    }

                    // O id da própria aba: sem ele a tela não tem como pedir o
                    // próprio fechamento, que hoje só sai do ✕ da barra.
                    if (invokeClass.setTabId) {
                        invokeClass.setTabId(itemData.ID)
                    }

                    if (invokeClass.setElementId) {
                        invokeClass.setElementId(itemData.idRegistro)
                    }

                    if (invokeClass.setComponenteTab) {
                        invokeClass.setComponenteTab($(itemElement));
                    }

                    if (Object.getPrototypeOf(itemData.classe) == PopUpPadrao) {
                        this.removeTab(itemData.ID)
                        invokeClass.getRender().appendTo($('.raster-app'));
                        invokeClass.getDxPopUp().show();
                        return
                    }

                    $(itemElement).css("overflow", "auto");

                    const doRender = invokeClass.getRender();

                    if (doRender instanceof Promise) {
                        const firstRender = await doRender

                        $(itemElement).append(firstRender)
                    } else {
                        $(itemElement).append(doRender)
                    }

                    if (invokeClass.callbackAfterRender) {
                        const callbackAfterRender = invokeClass.callbackAfterRender(itemElement);

                        if (callbackAfterRender instanceof Promise) {
                            await callbackAfterRender
                        } else {
                            callbackAfterRender
                        }
                    }
                } catch (err) {
                    console.error(err);
                    var msg = $('<div><b><center>' + err + '</center></b></div>');
                    msg.appendTo(itemElement);
                }
            }
        });

        return {
            content,
            instance
        }
    }

    async incluiTab(titleTab, classe, idRegistro = {}, opcoes = {}) {
        try {
            const classContent = await importTelas[classe];

            const novaTab = {
                ID: this.idGlobal,
                nomeTela: titleTab ?? 'Aba sem título',
                idRegistro: idRegistro,
                classe: classContent[classe],
                fixa: Boolean(opcoes.fixa),

                // O nome da classe, e não o construtor: é ele que o menu usa
                // para casar a aba com o item (TLA_CLASSEGRID).
                classInvoke: classe
            };

            // A aba fixa é sempre a primeira da barra de abas.
            if (novaTab.fixa) {
                this.tabPanelItems.unshift(novaTab);
            } else {
                this.tabPanelItems.push(novaTab);
            }

            const tabItens = this.tabPanelItems;

            this.tabPanelInstance.option("dataSource", tabItens);
            this.tabPanelInstance.option(
                "selectedIndex",
                novaTab.fixa ? 0 : tabItens.length - 1
            );

            // Ocultar o botão flutuante quando uma nova tela for aberta
            this.hideFloatingChatButton();

            // Último ponto por onde passa toda abertura de tela, venha do menu,
            // do acesso rápido ou de um CTA. A aba fixa fica de fora: a Início
            // não é um acesso, é onde a lista aparece. (JOR4-7663 / RN10)
            // Pelo mesmo motivo é aqui que as telas sem rastreamento registram
            // o acesso no analytics. (JOR4-7826)
            if (!novaTab.fixa) {
                registrarAcessoRecente(novaTab.nomeTela, classe);
                registrarAcessoTela(classe);
            }

            this.idGlobal++;
        } catch (e) {
            console.log(e)
        }
    }

    /**
     * Abre uma aba fixa: sempre a primeira da barra, sem botão de fechar e
     * reexibida automaticamente quando todas as demais abas são fechadas.
     * (JOR4-7363 / RN08)
     */
    async incluiTabFixa(titleTab, classe, idRegistro = {}) {
        if (this.tabPanelItems.some((tab) => tab.fixa)) {
            return this.selecionaTabFixa();
        }

        this.classeTabFixa = { titulo: titleTab, classe, idRegistro };

        await this.incluiTab(titleTab, classe, idRegistro, { fixa: true });
    }

    /**
     * Seleciona a aba fixa já aberta. Retorna false quando não existe nenhuma.
     */
    selecionaTabFixa() {
        const indiceTabFixa = this.tabPanelItems.findIndex((tab) => tab.fixa);

        if (indiceTabFixa == -1) return false;

        this.tabPanelInstance.option("selectedIndex", indiceTabFixa);

        return true;
    }

    removeTab(tabId) {
        const findTabindex = this.tabPanelItems.findIndex((tab) => tab.ID == tabId)

        if (findTabindex == -1) return;

        const actualTab = this.tabPanelItems[findTabindex]

        // Abas fixas não podem ser fechadas por nenhum meio.
        if (actualTab.fixa) return;

        this.getClasseIniciada(actualTab.classe.name, actualTab.ID).destroy()

        this.tabPanelItems.splice(findTabindex, 1);

        this.tabPanelInstance.option("items", this.tabPanelItems);

        const restamAbasComuns = this.tabPanelItems.some((tab) => !tab.fixa);

        if (restamAbasComuns) return;

        // Fechou a última aba comum: a aba fixa volta a ser a aba ativa. Se ela
        // não estiver mais montada (ex.: falha no bootstrap), reabre.
        if (!this.selecionaTabFixa()) {
            if (this.classeTabFixa) {
                this.incluiTabFixa(
                    this.classeTabFixa.titulo,
                    this.classeTabFixa.classe,
                    this.classeTabFixa.idRegistro
                );
            } else {
                this.tabPanelInstance.option("selectedIndex", -1);
            }
        }

        if (!this.tabPanelItems.length) {
            // Mostrar o botão flutuante quando todas as abas forem fechadas
            this.showFloatingChatButton();
        }

        // Fechar aba muda o foco sem necessariamente disparar
        // onSelectionChanged — em especial ao fechar a última.
        this.notificarTelaAtiva()
    }

    /**
     * Registra um assinante do foco de aba e já o chama com o estado atual,
     * para quem chega depois não ficar dessincronizado.
     *
     * @param {(classInvoke: string | null) => void} ouvinte
     */
    aoMudarTelaAtiva(ouvinte) {
        this.ouvintesTelaAtiva.push(ouvinte)
        // Pelo `avisar`, e não direto: esta chamada acontece dentro do render do
        // MenuNavegacao, e um assinante que estourasse aqui abortaria o render
        // antes do autoHeight().
        this.avisar(ouvinte, this.classeTelaAtiva())
    }

    /** TLA_CLASSEGRID da aba em foco, ou null quando não há aba aberta. */
    classeTelaAtiva() {
        const indice = this.tabPanelInstance.option("selectedIndex")
        const aba = this.tabPanelItems[indice]

        return aba ? aba.classInvoke ?? null : null
    }

    notificarTelaAtiva() {
        const classe = this.classeTelaAtiva()

        this.ouvintesTelaAtiva.forEach((ouvinte) => {
            this.avisar(ouvinte, classe)
        })
    }

    /** Um assinante quebrado não pode derrubar quem o avisa. */
    avisar(ouvinte, classe) {
        try {
            ouvinte(classe)
        } catch (e) {
            console.error(e)
        }
    }

    slugfy(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
        var to = "aaaaaeeeeeiiiiooooouuuunc------";
        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return str;
    };

    get instance() {
        return this.renderTabPanel.instance
    }

    setTabName(nome) {
        let elemento = $(this.titleElements[this.tabPanelInstance.option("selectedIndex")]);
        $(elemento).text(nome);
    }

    hideFloatingChatButton() {
        if (!ControleSessao.getUsuarioInterno()) {
            return;
        }

        const chatButton = document.getElementById('floating-chat-btn');
        if (chatButton) {
            chatButton.style.display = 'none';
        }
        if (this.chatAssistantOpen && this.popupChatInstance) {
            this.popupChatInstance.hide();
            this.chatAssistantOpen = false;
        }
    }

    showFloatingChatButton() {
        if (!ControleSessao.getUsuarioInterno()) {
            return;
        }

        const chatButton = document.getElementById('floating-chat-btn');
        if (chatButton) {
            chatButton.style.display = 'flex';
        }
    }

    getClasseIniciada(classeName, tabId) {
        return this.classesIniciadas[`${classeName}_${tabId}`]
    }

    createFloatingChatButton() {
        if (!ControleSessao.getUsuarioInterno()) {
            return;
        }

        const floatingButton = $(`
            <div id="floating-chat-btn" style="
                position: fixed;
                bottom: 30px;
                right: 30px;
                width: 60px;
                height: 60px;
                background: linear-gradient(135deg, #007acc, #0056a3);
                border-radius: 50%;
                box-shadow: 0 4px 12px rgba(0, 122, 204, 0.3);
                cursor: pointer;
                z-index: 10000;
                display: flex;
                align-items: center;
                justify-content: center;
                border: none;
            " title="Falar com assistente de jornada">
                <svg width="24" height="24" fill="white" viewBox="0 0 24 24" style="display: block; margin: 0; padding: 0;">
                    <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
                </svg>
            </div>
        `);

        floatingButton.hover(
            function() {
                $(this).css({
                    'box-shadow': '0 6px 16px rgba(0, 122, 204, 0.4)'
                });
            },
            function() {
                $(this).css({
                    'box-shadow': '0 4px 12px rgba(0, 122, 204, 0.3)'
                });
            }
        );

        floatingButton.click(() => {
            this.toggleChatAssistant();
        });

        $('body').append(floatingButton);
    }

    toggleChatAssistant() {
        if (!this.chatPopup) {
            this.createAndShowChat();
            registrarAcessoChatFlutuante();
            return;
        }

        if (this.chatPopup.option('visible')) {
            this.chatPopup.hide();
        } else {
            this.chatPopup.show();
            registrarAcessoChatFlutuante();
        }
    }

    createAndShowChat() {
        if (!$('#chat-popup-container').length) {
            $('body').append('<div id="chat-popup-container"></div>');
        }

        this.chatPopup = new dxPopup($('#chat-popup-container'), {
            width: 400,
            height: 500,
            title: '',
            showTitle: false,
            showCloseButton: false,
            position: {
                my: 'right bottom',
                at: 'right bottom',
                offset: '-50 -100'
            },
            dragEnabled: true,
            resizeEnabled: true,
            animation: false,
            closeOnOutsideClick: false,
            propagateOutsideClick: true,
            contentTemplate: () => {
                return this.createChatContent();
            },
            onShown: () => {
                this.setupChatEvents();
            }
        });

        this.chatPopup.show();
    }

    createChatContent() {
        return $(`
            <div id="chat-assistant-content" style="height: 100%; display: flex; flex-direction: column; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
                <div id="chat-header" style="
                    background: linear-gradient(135deg, #007acc, #0056a3);
                    color: white;
                    padding: 15px;
                    border-radius: 8px 8px 0 0;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                ">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <svg width="20" height="20" fill="white" viewBox="0 0 24 24">
                            <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
                        </svg>
                        Assistente de Jornada
                    </div>
                    <button id="chat-close-btn" style="
                        background: transparent;
                        border: none;
                        color: white;
                        cursor: pointer;
                        padding: 5px;
                        border-radius: 50%;
                        width: 30px;
                        height: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 18px;
                        font-weight: bold;
                    " title="Fechar chat">
                        ×
                    </button>
                </div>
                <div id="chat-messages" style="
                    flex: 1;
                    padding: 20px;
                    overflow-y: auto;
                    background: #f8f9fa;
                    min-height: 300px;
                ">
                    <div class="assistant-message" style="
                        background: white;
                        padding: 12px 15px;
                        border-radius: 18px 18px 18px 4px;
                        margin-bottom: 15px;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                        max-width: 80%;
                    ">
                        Olá! Sou o assistente de jornada. Estou aqui para esclarecer suas dúvidas sobre o sistema de controle de jornada.
                        <br><br>
                        <strong>Digite suas perguntas sobre:</strong>
                        <ul style="margin: 10px 0 0 20px; font-size: 13px;">
                            <li>Como usar o controle de ponto</li>
                            <li>Configurações e regras do sistema</li>
                            <li>Dúvidas sobre funcionalidades</li>
                        </ul>
                    </div>
                </div>
                <div id="chat-input-area" style="
                    padding: 15px;
                    background: white;
                    border-top: 1px solid #e9ecef;
                    display: flex;
                    gap: 10px;
                ">
                    <input type="text" id="chat-input" placeholder="Digite sua mensagem..." style="
                        flex: 1;
                        padding: 10px 15px;
                        border: 1px solid #ddd;
                        border-radius: 25px;
                        outline: none;
                        font-size: 14px;
                    ">
                    <button id="chat-send-btn" style="
                        background: linear-gradient(135deg, #007acc, #0056a3);
                        color: white;
                        border: none;
                        border-radius: 50%;
                        width: 40px;
                        height: 40px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    ">
                        <svg width="16" height="16" fill="white" viewBox="0 0 24 24">
                            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                        </svg>
                    </button>
                </div>
            </div>
        `);
    }

    setupChatEvents() {
        setTimeout(() => {
            const input = $('#chat-input');
            const sendBtn = $('#chat-send-btn');
            const closeBtn = $('#chat-close-btn');
            const messagesArea = $('#chat-messages');

            // Permitir scroll natural na área de mensagens
            messagesArea.on('wheel', (e) => {
                e.stopPropagation();
            });

            messagesArea.on('touchmove', (e) => {
                e.stopPropagation();
            });

            let isWaitingForResponse = false;

            closeBtn.click(() => {
                this.chatPopup.hide();
            });

            const sendMessage = async () => {
                const message = input.val().trim();
                if (!message || isWaitingForResponse) return;

                isWaitingForResponse = true;
                input.prop('disabled', true);
                sendBtn.prop('disabled', true);
                sendBtn.css('opacity', '0.5');
                input.css('opacity', '0.5');

                const userMessage = $(`
                    <div class="user-message" style="
                        background: linear-gradient(135deg, #007acc, #0056a3);
                        color: white;
                        padding: 12px 15px;
                        border-radius: 18px 18px 4px 18px;
                        margin-bottom: 15px;
                        margin-left: auto;
                        max-width: 80%;
                        text-align: right;
                    ">
                        ${message}
                    </div>
                `);

                messagesArea.append(userMessage);
                input.val('');

                const loadingMessage = $(`
                    <div class="assistant-message loading" style="
                        background: white;
                        padding: 12px 15px;
                        border-radius: 18px 18px 18px 4px;
                        margin-bottom: 15px;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                        max-width: 80%;
                        color: #666;
                    ">
                        Digitando...
                    </div>
                `);

                messagesArea.append(loadingMessage);
                messagesArea.scrollTop(messagesArea[0].scrollHeight);

                try {

                    const fullUrl = `${process.env.AI_SERVICE_URL}/ask`;

                    const requestData = { query: message };

                    const fetchConfig = {
                        method: 'POST',
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${process.env.AI_SERVICE_TOKEN}`
                        },
                        body: JSON.stringify(requestData)
                    };

                    const response = await fetch(fullUrl, fetchConfig);


                    if (!response.ok) {
                        console.error('Response não OK. Status:', response.status, 'StatusText:', response.statusText);
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();

                    loadingMessage.remove();

                    const assistantMessage = $(`
                        <div class="assistant-message" style="
                            background: white;
                            padding: 12px 15px;
                            border-radius: 18px 18px 18px 4px;
                            margin-bottom: 15px;
                            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                            max-width: 80%;
                        ">
                            ${data.response || 'Desculpe, não consegui processar sua solicitação.'}
                        </div>
                    `);

                    messagesArea.append(assistantMessage);
                    messagesArea.scrollTop(messagesArea[0].scrollHeight);

                    isWaitingForResponse = false;
                    input.prop('disabled', false);
                    sendBtn.prop('disabled', false);
                    input.css('opacity', '1');
                    sendBtn.css('opacity', '1');
                    input.focus();

                } catch (error) {

                    loadingMessage.remove();

                    let errorMsg = 'Desculpe, ocorreu um erro ao processar sua mensagem.';

                    if (error.name === 'TypeError' && error.message.includes('fetch')) {
                        errorMsg = 'Erro de conexão. Verifique sua conexão com a internet.';
                        console.error('DIAGNÓSTICO: Erro de fetch - possível problema de rede ou CORS');
                    } else if (error.message.includes('CORS')) {
                        errorMsg = 'Erro de CORS. O servidor precisa permitir requisições do frontend.';
                        console.error('DIAGNÓSTICO: Erro de CORS - servidor não permite requisições do frontend');
                    } else if (error.message.includes('HTTP error')) {
                        errorMsg = `Erro do servidor: ${error.message}`;
                        console.error('DIAGNÓSTICO: Erro HTTP - servidor retornou status de erro');
                    } else if (error.message.includes('JSON')) {
                        errorMsg = 'Erro ao processar resposta do servidor.';
                        console.error('DIAGNÓSTICO: Erro de JSON - resposta não é um JSON válido');
                    }

                    // Mostrar mensagem de erro
                    const errorMessage = $(`
                        <div class="assistant-message" style="
                            background: #ffebee;
                            color: #c62828;
                            padding: 12px 15px;
                            border-radius: 18px 18px 18px 4px;
                            margin-bottom: 15px;
                            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                            max-width: 80%;
                        ">
                            ${errorMsg}<br><small>Verifique o console para mais detalhes.</small>
                        </div>
                    `);

                    messagesArea.append(errorMessage);
                    messagesArea.scrollTop(messagesArea[0].scrollHeight);

                    isWaitingForResponse = false;
                    input.prop('disabled', false);
                    sendBtn.prop('disabled', false);
                    input.css('opacity', '1');
                    sendBtn.css('opacity', '1');
                    input.focus();
                }
            };

            // Evento de clique no botão
            sendBtn.click(sendMessage);

            // Evento de Enter no input
            input.keypress((e) => {
                if (e.which === 13) { // Enter
                    sendMessage();
                }
            });

            // Foco no input
            input.focus();
        }, 100);
    }
}
